/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'

interface Props extends React.HTMLProps<HTMLDivElement> {
  onClick?: () => void
  stroke?: string
  add?: boolean
}

const IconAdd = ({ onClick, stroke = 'black', add = true }: Props) => {
  return (
    <div
      className="shelf-arrow-left-container"
      onClick={onClick}
      onKeyDown={onClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" fill="white" />
        <circle cx="12" cy="12" r="8" fill="white" />
        {add && (
          <path
            d="M12 8V16"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}

        <path
          d="M8 12H16"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default IconAdd
